import styled from 'styled-components';
import Carousel from 'antd/es/carousel';

import { Row } from '@components/formStyles';
import IconLabel from '@components/ui/labels/icon/IconLabel';

export const RoomCard = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.grey300};
  border-bottom: 0;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  position: relative;
`;

export const PriceCard = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.grey300};
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-top: 0;
  position: relative;
  padding: 24px 16px;
  height: 220px;
`;

export const Line = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${({ theme }) => theme.palette.grey300};
`;

export const Title = styled.span`
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  color: ${({ theme }) => theme.palette.grey1100};
  margin-bottom: 12px;
  white-space: normal;
`;

export const Subtitle = styled.span`
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  margin-left: 8px;
  color: ${({ theme }) => theme.palette.grey1100};
`;

export const StyledCarousel = styled(Carousel)`
  &&& {
    cursor: pointer;
    width: 244px;
    .setur-carousel {
      height: 100% !important;
    }

    & .setur-slider-dot li {
      margin-right: 8px;
    }

    & .setur-carousel .setur-slick-dots li button {
      height: 8px !important;
      width: 8px !important;
      border-radius: 50% !important;
      z-index: 2;
    }

    & .setur-slick-dots {
      display: none !important;
    }

    @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
      width: 100%;
      & .setur-slick-dots {
        display: block !important;
      }
    }
  }
`;

export const Features = styled(Row)`
  margin-top: 8px;
`;

export const Wrapper = styled.div`
  padding: 24px 16px;
  height: 200px;
`;

export const RoomInfo = styled.span`
  color: ${({ theme }) => theme.palette.grey800};
  font-size: 10px;
  margin-bottom: 8px;
  font-weight: 700;
`;

export const StartPriceLabel = styled.span`
  font-size: 10px;
  margin: 2px 0;

  font-weight: 400;
  word-wrap: break-word;
  display: block;
  white-space: pre-wrap;
  color: ${({ theme }) => theme.palette.grey1100};
`;
export const StyledIconLabel = styled(IconLabel)`
  align-items: center;
  flex-direction: inherit;
  border-radius: 8px;
  padding: 8px;
  height: 36px;
  margin-top: 4px;
  width: fit-content;
  & span {
    font-size: 14px !important;
    font-weight: 400 !important;
  }
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-left: 0;
    margin-top: 10px;
    align-items: center;
  }
`;
